import { Brand } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";
import { brandAssetsUrl } from "./cmdCreateBrandAsset";

/** Archives an asset. Archiving the Primary logo leaves the default logo where it is. */
export class CommandArchiveBrandAsset {
    async run(organizationId: string, brandId: string, assetId: number): Promise<Brand> {
        const url = `${brandAssetsUrl(organizationId, brandId)}${assetId}`;
        const response = await httpRequest<any>(url, { method: "DELETE" });
        return new BrandSerializer().deserialize(response);
    }
}
